import { render, staticRenderFns } from "./UserModal.vue?vue&type=template&id=c5fccb98&scoped=true"
import script from "./UserModal.vue?vue&type=script&lang=js"
export * from "./UserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fccb98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5fccb98')) {
      api.createRecord('c5fccb98', component.options)
    } else {
      api.reload('c5fccb98', component.options)
    }
    module.hot.accept("./UserModal.vue?vue&type=template&id=c5fccb98&scoped=true", function () {
      api.rerender('c5fccb98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/UserModal.vue"
export default component.exports